import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updatePdfPreview } from '@components/settings/actions';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui';
import VisuallyHiddenLegend from '@shared/visually-hidden-legend';
import UnstyledHeading from '@shared/unstyled-heading';
import './settings.scss';

const FilePreview = () => {
  const { global: { pdf_preview = 'browser' } } = useSelector(state => state.config);
  const dispatch = useDispatch();

  const onChange = event => dispatch(updatePdfPreview(event.target.value));

  return (
    <div styleName="settings-form-container">
      <div styleName="title">
        <UnstyledHeading rank={2}>
          <div styleName="text">File Preview</div>
        </UnstyledHeading>
      </div>
      <div styleName="hint">
        Choose how PDF attachments are previewed. Use the Google Docs Viewer only if your browser can&apos;t display PDFs.
      </div>
      <div styleName="form">
        <FormControl component="fieldset">
          <VisuallyHiddenLegend>PDF preview</VisuallyHiddenLegend>
          <RadioGroup aria-label="pdf preview" name="pdfPreview" value={pdf_preview} onChange={onChange}>
            <FormControlLabel value="browser" control={<Radio color="primary" />} label="Browser PDF Viewer" />
            <FormControlLabel value="google" control={<Radio color="primary" />} label="Google Docs Viewer" />
          </RadioGroup>
        </FormControl>
      </div>
    </div>
  );
};

export default memo(FilePreview);
